const _launchUrlString = "/_launch_/";
export function launch(app, rsx) {
    if (typeof rsx !== "string" || rsx.indexOf(_launchUrlString) === -1) {
        return;
    }
    if (!urlAtCurrentPage(app, rsx)) {
        window.location.href = rsx;
        return;
    }
    const sdk = typeof CasinoWidget === "undefined" ? undefined : CasinoWidget.sdk();
    if (!sdk) {
        return;
    }
    sdk.startGame(rsx);
}
function urlAtCurrentPage(app, url) {
    if (url.lastIndexOf(_launchUrlString, 0) === 0) {
        return true;
    }
    const page = app.Navigation.pageNavigationConfig.FullPagePath;
    return page ? url.indexOf(page) !== -1 : false;
}
//# sourceMappingURL=Launch.js.map